var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content-box"},[_c('iframe',{staticStyle:{"width":"12rem","height":"680px"},attrs:{"src":_vm.url,"frameborder":"0"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }